$(document).ready(function() {
  $(".feature-block").on("click", function() {
    $(this).toggleClass("clicked");
  });
});
